<template>
  <section class="section-product-detail-page bg-grey">
    <div class="container">
      <div class="row m-0">
        <div class="col-12">
          <div class="content py-0">
            <h2 class="section-title page-title h2 text-center text-black f-44 h2-caslon">Electrical & Electronics</h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-product-detail-page bg-primary">
    <div class="container">
      <div class="page-content">

        <div class="content">
          <ContentsTextWithImage
            title="Electrical & Electronics"
            image-url="/pages/products/industries/electric.jpg"
            :contents="[
              'Electronics has long been the core industry of Thailand. With government support, highly skilled employees and complete ecosystem manufacturers has chosen Thailand for their manufacturing base to support various industries. Electronics parts require higher performance and more demanding standard as end applications are more sophisticated. Our materials are chosen because of its compliance with international standard like ROHS, REACH, UL etc. We offer variety of properties like non halogenated FR technology, superb electrical and dielectric properties, stable dk, df, low outgassing, high cleanliness, excellent dimension, high heat and extreme chemical resistance, good wear and friction and so on. It is widely used in different market from hard disk drive, semiconductor, home appliances, automation, automotive, and smart electronics',
            ]"
            is-reverse="true"
            is-white-content="true"
            is-content-small-text="true"
            left-width="45.805%"
            right-width="54.195%"
          />
        </div>
        
      </div>
    </div>
  </section>

  <section class="section-gallery bg-grey">

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ee01.jpg" alt="Circuit breaker">
                      </a>
                    </div>
                    <div class="card-content text-center ">
                      <a href="#" class="card-title f-21">Circuit breaker</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ee02.jpg" alt="Wall switch">
                      </a>
                    </div>
                    <div class="card-content text-center ">
                      <a href="#" class="card-title f-21">Wall switch</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ee03.jpg" alt="Connector">
                      </a>
                    </div>
                    <div class="card-content text-center ">
                      <a href="#" class="card-title f-21">Connector</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-product-detail-page">
      <div class="container page-container">
        <div class="row m-0">
          <div class="col-12">
            <div class="content">

              <div class="row m-0">
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ee04.jpg" alt="Motor">
                      </a>
                    </div>
                    <div class="card-content text-center ">
                      <a href="#" class="card-title f-21">Motor</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>

                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/ee05.jpg" alt="HDD components">
                      </a>
                    </div>
                    <div class="card-content text-center ">
                      <a href="#" class="card-title f-21">HDD companents</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
                <div class="col-12 col-md-4 p-0">
                  <!-- CARD IMAGE -->
                  <div class="card-image">
                    <div class="image-wrapper">
                      <a href="#">
                        <img src="/pages/products/industries/b-sermical.jpg" alt="Semicon handling">
                      </a>
                    </div>
                    <div class="card-content text-center ">
                      <a href="#" class="card-title f-21">Semicon handling</a>
                    </div>
                  </div>
                  <!-- CARD IMAGE -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <div v-show="isMoreGalleryShow">
      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee07.jpg" alt="JDEC tray">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">JDEC tray</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper ">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee08.jpg" alt="Lens module">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">Lens module</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee09.jpg" alt="Relay">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">Relay</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee10.jpg" alt="PCB connector">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">PCB connector</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee11.jpg" alt="Junction box">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">Junction box</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee12.jpg" alt="Electric wire cable">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">Electric wire cable</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section-product-detail-page">
        <div class="container page-container">
          <div class="row m-0">
            <div class="col-12">
              <div class="content">

                <div class="row m-0">
                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee13.jpg" alt="Cooling fan">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">Cooling fan</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee14.jpg" alt="Fiber optic">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">Fiber optic</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>

                  <div class="col-12 col-md-4 p-0">
                    <!-- CARD IMAGE -->
                    <div class="card-image">
                      <div class="image-wrapper">
                        <a href="#">
                          <img src="/wp-content/uploads/2022/07/ee15.jpg" alt="Transceiver">
                        </a>
                      </div>
                      <div class="card-content text-center ">
                        <a href="#" class="card-title f-21">Transceiver</a>
                      </div>
                    </div>
                    <!-- CARD IMAGE -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="section-product-detail-page pt-3">
      <div class="container page-container">
        <div class="content text-center">
          <button
            class="btn btn-link text-primary text-decoration-none f-15 outline-none"
            @click="handleLoadmoreClick"
          >
            {{ loadMoreButtonText }}
          </button>
        </div>
      </div>
    </section>

  </section>
</template>
<script setup lang="ts">
useHead({
  title:'Electrical & Electronics - NAGASE THAILAND Engineering Plastics',
})

const isMoreGalleryShow = useState<Boolean>('isMoreGalleryShow', () => false)
const loadMoreButtonText = useState<String>('loadMoreButtonText', () => 'Read More')

const handleLoadmoreClick = () => {
  isMoreGalleryShow.value = !isMoreGalleryShow.value
  loadMoreButtonText.value = isMoreGalleryShow.value ? 'Read Less' : 'Read More'
}
</script>

<style scoped>
.page-title {
  padding-bottom: 85px;
}

.section-gallery {
  padding-top: 60px;
  padding-bottom: 60px;
}

.text-custom{
  font-size: 37px !important;
}
</style>